import { createIcon } from '@chakra-ui/react';

export const VerifyMagicLinkMailIcon = createIcon({
  displayName: 'VerifyMagicLinkMailIcon',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
    >
      <path
        d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
        fill="#8877CE"
      />
      <path
        d="M100 50C100 74.427 82.4865 94.7622 59.3298 99.1297L20.5352 68.4487L79.4595 31.546L99.946 47.746C99.9838 48.4973 100 49.2433 100 50Z"
        fill="#391CAD"
      />
      <path
        d="M79.4647 31.5459C79.0755 31.1892 78.5458 30.973 77.9782 30.973H22.0269C21.4539 30.973 20.9296 31.1838 20.5404 31.5459C20.081 31.9621 19.7891 32.5513 19.7891 33.2108V66.7784C19.7891 67.4378 20.081 68.0324 20.5404 68.4432C20.9296 68.8 21.4593 69.0162 22.0269 69.0162H77.9782C78.562 69.0162 79.0864 68.8054 79.4756 68.4324C79.935 68.0162 80.2161 67.427 80.2161 66.7784V33.2108C80.2107 32.5567 79.9188 31.9621 79.4647 31.5459Z"
        fill="#FE9C28"
      />
      <path
        d="M44.7517 49.9999L20.5355 68.454C20.0761 68.0378 19.7842 67.4486 19.7842 66.7891V33.2216C19.7842 32.5621 20.0761 31.9675 20.5355 31.5567L44.7517 49.9999Z"
        fill="#FEBD00"
      />
      <path
        d="M80.2107 33.2162V66.7838C80.2107 67.4324 79.9296 68.027 79.4702 68.4379L55.2485 50L79.4648 31.546C79.9188 31.9622 80.2107 32.5568 80.2107 33.2162Z"
        fill="#FEBD00"
      />
      <path
        d="M79.4649 31.5459L55.2486 50L51.5351 52.8324C50.627 53.5351 49.373 53.5351 48.4703 52.8324L44.7567 50L20.5405 31.5459C20.9297 31.1892 21.4594 30.973 22.027 30.973H77.9784C78.5459 30.9784 79.0703 31.1892 79.4649 31.5459Z"
        fill="#FFD734"
      />
      <path
        d="M79.222 38.0216C83.2462 38.0216 86.5085 34.7593 86.5085 30.7351C86.5085 26.7109 83.2462 23.4486 79.222 23.4486C75.1978 23.4486 71.9355 26.7109 71.9355 30.7351C71.9355 34.7593 75.1978 38.0216 79.222 38.0216Z"
        fill="#E04149"
      />
      <path
        d="M78.6973 33.2162V28.5297L77.6216 29.1189V28.1405L79 27.3838H79.8648V33.2162H80.8216V34.0865H77.6594V33.2162H78.6973Z"
        fill="white"
      />
    </svg>
  ),
});
